export default __webpack_public_path__ + "static/media/prod-img-1.e4a71867.webp";